import CloseIcon from "@mui/icons-material/Close"
import { Alert, AlertTitle, Box, CircularProgress, Dialog, DialogContent, DialogTitle, Grid, IconButton } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import React, { useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  miSolicitudActualizacionCuentaBancaria,
  miSolicitudActualizacionEducacion,
  miSolicitudActualizacionFamiliar,
  miSolicitudCambioDomicilio,
  miSolicitudCambioEstadoCivil,
} from "../../Redux/solicitudes"
import { COLUMNSOLICITUD } from "../../columnas/columnaSolicitud"
import { UserAuth } from "../../context/AuthContext"
import TokenContext from "../../context/TokenContext"
import Tabla from "../Tabla"

const ModalMisSolicitudes = ({ open, handleClose, tipoSolicitud }) => {
  const token = useContext(TokenContext)
  const dispatch = useDispatch()
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"))
  const { empleado } = UserAuth()

  const solicitudSelector = useSelector((store) => store.solicitudes.solicitud)
  const loadSolicitudSelector = useSelector((store) => store.solicitudes.getSolicitud)
  const [solicitud, setSolicitud] = useState([])

  useEffect(() => {
    if (token.length > 0 && Object.keys(empleado).length > 0) {
      if (tipoSolicitud === "domicilio") {
        dispatch(miSolicitudCambioDomicilio(token, empleado.empleadoid))
      }
      if (tipoSolicitud === "estado civil") {
        dispatch(miSolicitudCambioEstadoCivil(token, empleado.empleadoid))
      }
      if (tipoSolicitud === "familia") {
        dispatch(miSolicitudActualizacionFamiliar(token, empleado.empleadoid))
      }
      if (tipoSolicitud === "educacion") {
        dispatch(miSolicitudActualizacionEducacion(token, empleado.empleadoid))
      }
      if (tipoSolicitud === "cuenta bancaria") {
        dispatch(miSolicitudActualizacionCuentaBancaria(token, empleado.empleadoid))
      }
    }
  }, [token, empleado, tipoSolicitud])

  useEffect(() => {
    if (solicitudSelector?.length > 0) {
      const array = []
      solicitudSelector.forEach((item) => {
        let obj = {
          id: item.new_solicitudcambiodedomicilioid,
          solicitud: item.new_name,
          mensaje: item["new_estadosolicitud@OData.Community.Display.V1.FormattedValue"],
        }
        array.push(obj)
      })
      setSolicitud(array)
    } else if (solicitudSelector?.length == 0) {
      setSolicitud([])
    }
  }, [solicitudSelector])

  return (
    <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
      <DialogTitle sx={{ justifyContent: "center", my: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            p: 1,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{px:"15px", ml:"15px"}}>
        <Grid container spacing={2} sx={{ mt: 2, minWidth: "300px" }}>
          {!loadSolicitudSelector ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                py: 2,
              }}
            >
              <CircularProgress color="secondary" />
            </Box>
          ) : solicitud.length > 0 ? (
            <Tabla columnas={COLUMNSOLICITUD} lineas={solicitud} />
          ) : (
            <Alert severity="info">
              <AlertTitle>Info</AlertTitle>
              Aún no tienes registros de esta <strong>solicitud</strong>.
            </Alert>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ModalMisSolicitudes
